import React, { useEffect, useRef, useState } from "react";
import { UserOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Image,
  InputNumber,
  Affix,
  Button,
  message,
  DatePicker,
  Space,
  Select,
  Flex,
  Input,
} from "antd";
import {
  getContactSearchResultbyPhone,
  getSpecificContact,
} from "../../../actions/contactAction";
import { getSpecificMeasurementbycontact } from "../../../actions/measurment";
import { getCuponSearchResult } from "../../../actions/cupon";
import CreateNewContct from "../CreateNewContct";
import { NotificationFilled } from "@ant-design/icons";
import dateFormat from "dateformat";

const Demo = ({
  getContactSearchResultbyPhone,
  getSpecificMeasurementbycontact,
  getSpecificContact,
  getCuponSearchResult,
  bill,
  setCart,
  id,
  triggerOpen 
}) => {
  const [showsuggetion, setshowsuggetion] = useState(false);
  const [contactsuggetions, setcontactsuggetions] = useState();
  const [contact, setcontact] = useState({});
  const [remove, setremove] = useState(false);
  const [timer, setTimer] = useState(null);
  const [searchPhone, setSearchPhone] = useState("");

  useEffect(() => {
    if (id > 0) {
      getSpecificContact(id).then((response) => {
        if (typeof response != "undefined") {
          getSpecificMeasurementbycontact(id).then((measurement) => {
            if (typeof measurement != "undefined") {
              bill.current.basicmeasurement = measurement[0];
            }
            setcontact(response);
            bill.current.Contact = response.id;
            if (parseFloat(response.account_balance) > 0) {
              bill.current.Payable = parseFloat(response.account_balance);
            } else {
              bill.current.Payable = 0;
            }
            setshowsuggetion(false);
            setremove(true);
            setCart(true);
          });
        }
      });
    }
  }, [id, getSpecificContact, getSpecificMeasurementbycontact, bill, setCart]);

  const onChange = (e) => {
    const value = e.target.value;
    setSearchPhone(value);

    if (timer) {
      clearTimeout(timer);
    }

    if (value.length === 2) {
      setTimer(
        setTimeout(() => {
          getContactSearchResultbyPhone(value).then((result) => {
            setcontactsuggetions(result);
            setshowsuggetion(true);
          });
        }, 2000)
      );
    } else if (value.length > 2) {
      getContactSearchResultbyPhone(value).then((result) => {
        setcontactsuggetions(result);
        setshowsuggetion(true);
      });
    } else {
      setshowsuggetion(false);
    }
  };
  
  const renderContact = () => {
    if (showsuggetion) {
      return contactsuggetions.map((contact, index) => {
        if (contact.Type == "Customer" && index < 10) {
          return (
            <Row
              key={contact.id}
              style={{
                border: "1px solid lightgray",
                padding: "5px",
                marginBottom: "1px",
                borderRadius: "5px",
              }}
              onClick={() => {
                setcontact(contact);
                getCuponSearchResult(contact.Cupon).then((result) => {
                  if (result.length === 1 && result[0].status === "Active") {
                    if (
                      (result[0].limit_type === "limited" &&
                        result[0].limit > 0) ||
                      result[0].limit_type === "Unlimited"
                    ) {
                      const currentdate = new Date();

                      const d1 = dateFormat(
                        result[0].start,
                        "yyyy-mm-dd HH:MM:ss"
                      );
                      const d2 = dateFormat(result[0].end, "yyyy-mm-dd HH:MM:ss");
                      const current = dateFormat(
                        currentdate,
                        "yyyy-mm-dd HH:MM:ss"
                      );
                      const date1 = new Date(d1);
                      const date2 = new Date(d2);
                      const currenttime = new Date(current);

                      const diff1 = currenttime.getTime() - date1.getTime();
                      const diff2 = date2.getTime() - currenttime.getTime();
                      const lte = diff1 / (1000 * 3600 * 24);
                      const gte = diff2 / (1000 * 3600 * 24);

                      if (lte >= 0 && gte >= 0) {
                        message.success("Coupon has been applied");
                        bill.current.Cupon = result[0];
                        setCart(true);
                      }
                    }
                  }
                });

                bill.current.Contact = contact.id;
                if (parseFloat(contact.account_balance) > 0) {
                  bill.current.Payable = parseFloat(contact.account_balance);
                } else {
                  bill.current.Payable = 0;
                }

                setshowsuggetion(false);
                setremove(true);
                setCart(true);
              }}
            >
              <Col span={17}>
                <h4 style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                  {contact.name}
                </h4>
              </Col>
              <Col span={6}>{contact.phone}</Col>
            </Row>
          );
        }
        return null;
      });
    }
  };
  return (
    <>
      {remove ? (
        <Row vertical>
          <Button Danger
            onClick={() => {
            setremove(false);
            setcontact(null);
            bill.current.Payable = 0;
            bill.current.Contact = null;
            setCart(true);
          }}
          // type="link"
          style={{color: "red", border: "1px solid red"}}
        >
          Remove Contact
        </Button>
        </Row>

   
      ) : (
        <Space direction="Horizontal" style={{ width: "100%" }}>
          <Input
            placeholder="Customer Phone Number"
            prefix={<UserOutlined />}
            // onKeyUp={onChange}
            onChange={onChange}

            style={{
              width: '100%',
            }}
          />
          <CreateNewContct bill={bill} setcontact={setcontact} triggerOpen={triggerOpen} phone={searchPhone}/>
        </Space>
        // "No customer was added"
      )}
      <div
        style={{
          position: "absolute",
          zIndex: "5",
          backgroundColor: "#F5F5F5",
          width: "100%",
        }}
      >
        {renderContact()}
      </div>
      <br></br>
      {contact ? (
            <>
            {/* {console.log(contact)} */}
            {contact.name ? (
              <>
                <Row>
                  <Col span={6}>
                    <b>Name</b>
                  </Col>
                  <Col span={18}>
                    <Input value={contact.name} disabled style={{color:"#545252"}} />
                  </Col>
                </Row> 
              </> 
              ) : (
                ""
                )}

            {contact.role ? (
              <>
                <Row>
                  <Col span={6}>
                    <b>Type</b>
                  </Col>
                  <Col span={18}>
                    <Input value={contact.Role} disabled style={{color:"#545252"}} />
                  </Col>
                </Row> 
              </>
            ) : (
              ""
            )}
            {contact.address ? (
              <>
                <Row>
                  <Col span={6}>
                    <b>Address</b>
                  </Col>
                  <Col span={18}>
                    <Input.TextArea value={contact.address} disabled style={{color:"#545252"}} />
                  </Col>
                </Row> 
              </>
            ) : (
              ""
            )}
      
            {contact.phone ? (
              <>
              <Row>
                  <Col span={6}>
                    <b>Phone</b>
                  </Col>
                  <Col span={18}>
                    <Input value={contact.phone} disabled style={{color:"#545252"}} />
                  </Col>
                </Row> 
              </>
            ) : (
              ""
            )}
          </>
        // <>
        //   {/* {console.log(contact)} */}
        //   {contact.name ? <h1>{contact.name}</h1> : ""}
        //   {contact.role ? (
        //     <>
        //       {contact.Role}
        //       <br></br>
        //     </>
        //   ) : (
        //     ""
        //   )}
        //   {contact.address ? (
        //     <>
        //       {contact.address}
        //       <br></br>
        //     </>
        //   ) : (
        //     ""
        //   )}

        //   {contact.phone ? "Phone : " + contact.phone : ""}
        // </>
      ) : (
        ""
      )}
    </>
  );
};
export default connect(null, {
  getContactSearchResultbyPhone,
  getSpecificContact,
  getSpecificMeasurementbycontact,
  getCuponSearchResult,
})(Demo);
